import type { ReactNode } from "react";

interface Props {
  title: string;
  description?: string;
  actions?: ReactNode;
}

export default function PageHeader({ title, description, actions }: Props) {
  return (
    <div className="bo-page-header">
      <div style={{ minWidth: 0 }}>
        <h1 className="bo-page-title">{title}</h1>
        {description && <p className="bo-page-description">{description}</p>}
      </div>
      {actions && <div className="bo-page-actions">{actions}</div>}
    </div>
  );
}
